/**
 * Mhc Service
 * --------------------
 * Provides functions to interact with MHC-related API endpoints.
 *
 * @author  Harvinder Singh
 * @created 2025-09-12
 */

import { ref, } from 'vue'
import { MhcHttpClient } from '@/lib/repositories'
import type { AxiosResponse } from 'axios'

// --- API Resource ---
const RESOURCE = 'merchants'

/**
 * useMhcService
 * --------------------
 */
export function useMhcService() {
  const httpClient = MhcHttpClient
  const isFetching = ref(false)

  // Reactive state
  const data = {
    items: ref<any[]>([]),
  }

  /**
   * Fetch all MHC accounts
   * @param config Optional Axios config (filters, pagination)
   * @returns AxiosResponse with any array
   */
  async function findAll(config: Record<string, unknown> = {}): Promise<AxiosResponse<any>> {
    isFetching.value = true
    try {
      const response = await httpClient.get<any>(RESOURCE, config)
      const payload = response.data

      data.items.value = payload.merchants ? payload.merchants : []

      return response
    } finally {
      isFetching.value = false
    }
  }

  // Public API
  return {
    isFetching,
    ...data,
    findAll
  }
}
